import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-MV5GN7J4',
};

export const initializeGTM = () => {
    TagManager.initialize(tagManagerArgs);
};
